module.exports = __webpack_public_path__ + "img/254fabfb5e7fdbb06dd400c8c592c77b.254fabfb.png";